<template>
  <div id="edit-email-pin" class="row verify-pin">
    <div class="col-md-1">
      <img
        src="@/assets/images/ic-arrow-left.svg"
        width="30"
        class="arrow mb-30"
        alt
        @click="changeComponent('Details')"
      />
    </div>
    <div class="col-md-11">
      <h2 class="header-title">Verification</h2>
      <p class="text-quote mt-20">
        We just sent you an email with 4-digit PIN.
        <br />Enter it to verify your email.
      </p>
      <div class="row mt-30">
        <div class="col-md-8">
          <b-form @submit.prevent="verifyEmail">
            <div class="mpin-input">
              <input
                ref="pin"
                class="form-control"
                v-model="form.pin"
                maxlength="pinLength"
                type="text"
                pattern="[0-9]*"
                inputmode="numeric"
                id="mpin"
              />
            </div>
            <div
              v-if="hasCustomerError('message')"
              class="invalid-feedback d-block mb-3"
            >
              <i
                class="bi bi-exclamation-circle text-danger mr-1"
                aria-hidden="true"
              ></i>
              {{ getCustomerError("message") }}
            </div>
            <div
              v-if="hasCustomerError('pin')"
              class="invalid-feedback d-block mb-3"
            >
              <i
                class="bi bi-exclamation-circle text-danger mr-1"
                aria-hidden="true"
              ></i>
              {{ getCustomerError("pin") }}
            </div>
            <div v-if="successMessage" class="text-success mb-3">
              <i
                class="bi bi-check-circle text-success mr-1"
                aria-hidden="true"
              ></i>
              {{ successMessage }}
            </div>
            <span style="font-size: 15px;">Didn't receive an email?</span>
            <b-button
              variant="link"
              class="resend-confirmation"
              :style="{
                color: webDesign.design.main_color
              }"
              :disabled="
                authIsLoading ||
                merchantIsLoading ||
                customerIsLoading ||
                isDisabledSendOTP ||
                isDisabledProceedBtn
              "
              @click="resendConfirmation()"
            >
              Resend Confirmation
              <span v-if="isDisabledSendOTP"> in {{ sendOTPTimeLeft }} </span>
            </b-button>
            <button
              type="submit"
              class="btn btn-core fw mt-20"
              :disabled="
                authIsLoading ||
                merchantIsLoading ||
                customerIsLoading ||
                isInvalidPinLength
              "
              v-if="webDesign !== null && webDesign.design !== null"
              :style="{
                backgroundColor: webDesign.design.main_color + '!important',
                border: 'none !important',
                color: webDesign.design.button_text_color + '!important',
              }"
            >
              PROCEED
            </button>
            <button
              type="submit"
              class="btn btn-core fw mt-20"
              :disabled="
                authIsLoading ||
                merchantIsLoading ||
                customerIsLoading ||
                isInvalidPinLength ||
                isDisabledProceedBtn
              "
              v-else
            >
              PROCEED
            </button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countdown = require("countdown-js");

import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "Verify",
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      authErrors: (state) => state.errors,
      authIsLoading: (state) => state.loading,
    }),
    ...mapState("customer", {
      customer: (state) => state.user,
      customerErrors: (state) => state.errors,
      customerIsLoading: (state) => state.loading,
      successMessage: (state) => state.successMessage,
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
    }),
    ...mapState("estore", {
      webDesign: (state) => state.webDesign,
    }),
    isInvalidPinLength() {
      return this.form.pin.length < this.pinLength;
    },
  },
  data() {
    return {
      form: {
        pin: "",
      },
      isDisabledSendOTP: false,
      sendOTPTimeLeft: "",
      pinLength: 4,
      thirtySeconds: 30000,
      oneHour: 3600000,
      isDisabledProceedBtn: false,
      countdownInterval: null
    };
  },
  methods: {
    changeComponent(component) {
      this.$emit("change-component", component);
      this.$emit("change-title", "Email Verified!");
      this.$emit("get-customer-profile");
    },
    async verifyEmail() {
      this.$store.dispatch("auth/resetErrors");
      this.$store.dispatch("customer/resetErrors");

      const recaptchaToken = await this.$recaptcha("verify_otp");

      let pin = this.form.pin;

      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          pin: pin,
          email: this.customer.email,
          "g-recaptcha-response": recaptchaToken,
        },
      };

      let _this = this;
      await this.$store
        .dispatch("customer/verifyOtpEmail", request)
        .then(function () {
          if (_this.customerErrors == null) {
            _this.changeComponent("Success");
          } else {
            _this.initializeSendOTPTimer();
          }
        });
    },
    async resendConfirmation() {
      this.$store.dispatch("customer/resetErrors");
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          mobile_number: this.customer.mobile_number,
          email: this.customer.email,
          membership_id: "",
          action: "VERIFY_EMAIL",
        },
      };
      await this.$store.dispatch("customer/sendOtp", request);
      this.initializeSendOTPTimer(true);
    },
    getCustomerError(field) {
      if (!this.customerErrors) return "";

      const errorField = this.customerErrors.errors[field];

      return Array.isArray(errorField) ? errorField[0] : errorField;
    },
    hasCustomerError(field) {
      if (!this.customerErrors) return false;

      return Boolean(this.customerErrors.errors[field]);
    },
    initializeSendOTPTimer(isResend=false) {
      const currentTime = this.hasCustomerError("current_time")
        ? moment(this.getCustomerError("current_time").date)
        : false;
      const updatedAt = this.hasCustomerError("updated_at")
        ? moment(this.getCustomerError("updated_at").date)
        : false;
      const duration =
        currentTime !== false && updatedAt !== false
          ? moment.duration(currentTime.diff(updatedAt))
          : false;
      const hasInvalidAttempts =
        this.hasCustomerError("message") &&
        this.getCustomerError("message").includes("60 mins")
        || (this.hasCustomerError("pin")
        && ((Array.isArray(this.customerErrors.errors['pin'])
          && this.customerErrors.errors['pin'].filter(msg => msg.includes("60 mins")))
          || this.customerErrors.errors['pin'].includes("60 mins")));

      const hasIntervalAttempt = 
        (this.hasCustomerError("message") &&
        this.getCustomerError("message").includes("30 seconds"))
        || (this.hasCustomerError("pin")
        && ((Array.isArray(this.customerErrors.errors['pin'])
          && this.customerErrors.errors['pin'].filter(msg => msg.includes("30 seconds")))
          || this.customerErrors.errors['pin'].includes("30 seconds")));

      if (this.customerErrors && !hasInvalidAttempts && !hasIntervalAttempt) return;

      let time = 
        duration !== false ? (this.thirtySeconds - duration.asMilliseconds()) : this.thirtySeconds;

      if (hasInvalidAttempts) {
        time =
          duration !== false ? (this.oneHour - duration.asMilliseconds()) : this.oneHour;
        if(!isResend) this.isDisabledProceedBtn = true;
        if(this.countdownInterval) this.countdownInterval.abort();
      }

      this.isDisabledSendOTP = true;
      this.countdownInterval = countdown.timer(
        new Date(new Date().getTime() + time),
        (timeLeft) => {
          if (timeLeft.hours === 1) {
            this.sendOTPTimeLeft = `${timeLeft.hours} hour`;
          } else if (timeLeft.hours === 0 && timeLeft.minutes < 1) {
            this.sendOTPTimeLeft = `${timeLeft.seconds} second${
              timeLeft.seconds > 1 ? "s" : ""
            }`;
          } else {
            this.sendOTPTimeLeft = `${timeLeft.minutes} minute${
              timeLeft.minutes > 1 ? "s" : ""
            } ${timeLeft.seconds} second${timeLeft.seconds > 1 ? "s" : ""}`;
          }
        },
        () => {
          this.isDisabledSendOTP = false;
          if(hasInvalidAttempts) this.isDisabledProceedBtn = false;
          this.countdownInterval = null;
        }
      );
    },
  },
  created() {
    this.$recaptchaInstance.showBadge();
    this.$nextTick(() => {
      this.$refs.pin.focus();
    });
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
  watch: {
    "form.pin"(pin) {
      this.form.pin = pin.replace(/\D/g, "");
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="text"]#mpin {
  -webkit-text-security: disc;
}
</style>
